import { FC, SVGProps } from 'react';

export const TimeIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.41176 16C5.41176 10.1523 10.1523 5.41176 16 5.41176C21.8477 5.41176 26.5882 10.1523 26.5882 16C26.5882 21.8477 21.8477 26.5882 16 26.5882C10.1523 26.5882 5.41176 21.8477 5.41176 16ZM16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4ZM16.3636 11.6429C16.3636 11.2878 16.0584 11 15.6818 11C15.3053 11 15 11.2878 15 11.6429V16.3901C15 16.5767 15.086 16.7541 15.2357 16.8762L18.872 19.8432C19.1567 20.0756 19.5873 20.0463 19.8337 19.7778C20.0802 19.5093 20.0491 19.1034 19.7643 18.871L16.3636 16.0963V11.6429Z"
			fill="currentColor"
		/>
	</svg>
);
